import React, { useState } from 'react';
import LoginModal from '@components/loginModal';
import MarketingPolicyAgreeModal from '@components/events/eventChallenge/modalsWrap/marketingPolicyAgreeModal';
import MarketingPolicyCompleteModal from '@components/events/eventChallenge/modalsWrap/marketingPolicyCompleteModal';

export const EventChallengeModalContext = React.createContext({
  setModalState: (modalType: EventChallengeModalType) => {
    return;
  },
});

export type EventChallengeModalType = 'LOGIN' | 'MARKETING_POLICY_AGREE' | 'MARKETING_POLICY_COMPLETE' | null;

interface IEventChallengeModalsProps {
  children: React.ReactNode;
}

const EventChallengeModalWrap = ({ children }: IEventChallengeModalsProps) => {
  const [modalState, setModalState] = useState<EventChallengeModalType>(null);

  const isVisible = (modalType: EventChallengeModalType) => modalType === modalState;
  const handleClose = () => setModalState(null);

  return (
    <EventChallengeModalContext.Provider value={{ setModalState }}>
      {children}
      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={isVisible('LOGIN')}
        onClose={handleClose}
      />
      {isVisible('MARKETING_POLICY_AGREE') && (
        <MarketingPolicyAgreeModal
          visible={isVisible('MARKETING_POLICY_AGREE')}
          onClose={handleClose}
          onOpenMarketingPolicyComplete={() => setModalState('MARKETING_POLICY_COMPLETE')}
        />
      )}
      {isVisible('MARKETING_POLICY_COMPLETE') && (
        <MarketingPolicyCompleteModal visible={isVisible('MARKETING_POLICY_COMPLETE')} onClose={handleClose} />
      )}
    </EventChallengeModalContext.Provider>
  );
};

export default EventChallengeModalWrap;
